<h2
  [ngClass]="dialogData?.type === 'FAQ' ? 'FAQ-heading' : null"
  class="d-flex justify-content-between uppercase"
>
  <span mat-dialog-title>
    @if (dialogData?.type === 'privacy-policy') {
      {{ multilingualService.langMap?.LABEL_PRIVACY_POLICY }}
    }

    @if (dialogData?.type === 'terms-of-use') {
      {{ multilingualService.langMap?.TITLE_REGISTRATION_FORM_TERMS_OF_USE }}
    }

    @if (dialogData?.type === 'FAQ') {
      {{ multilingualService.langMap?.LABEL_FAQS }}
    }
  </span>

  <button
    mat-dialog-close
    class="close"
    mat-icon-button
    [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
  >
    <mat-icon class="icon-cross"></mat-icon>
  </button>
</h2>

<mat-dialog-content class="mat-typography">
  <div>
    @if (dialogData?.type === 'privacy-policy') {
      <app-privacy-policy [isOpenedFromGuest]="true"></app-privacy-policy>
    }

    @if (dialogData?.type === 'terms-of-use') {
      <app-terms-of-use [isOpenedFromGuest]="true"></app-terms-of-use>
    }

    <div class="ml-2 mr-4">
      @if (dialogData?.type === 'FAQ') {
        <app-tpa-faq [isOpenedFromGuest]="true" [activeTabIndex]="activeFAQIndex"></app-tpa-faq>
      }
    </div>
  </div>
</mat-dialog-content>
